<div [formGroup]="form">

  <div *ngIf="isLoading; else loaded" class="text-center my-3">
    <div class="spinner-border" role="status">
      <span class="visually-hidden">Cargando...</span>
    </div>
    <p class="mt-2">Cargando información...</p>
  </div>

  <ng-template #loaded>

    <div class="row">
      <div class="col-xl-8 col-lg-12 col-md-12 col-sm-12 col-12">
        <h5 class="mt-2 mb-2">
          Usuario
        </h5>
        <div class="row">
          <div class="col-xl-6 col-lg-4 col-md-6 col-sm-6 col-12">
            <div class="form-group mb-3">
              <label class="required-field">Correo electrónico</label>
              @if(isViewMode) {
                <div class="form-control-plaintext">{{ form.get('email')?.value }}</div>
              } @else {
                <div class="input-group">
                  @if(isEditMode){
                    <input [value]="form.get('email')?.value" disabled type="email" class="form-control" />
                  }@else {
                    <input formControlName="email" type="email" class="form-control" />
                  }
                  <span class="input-group-text">
                    <i 
                      *ngIf="form.get('email')?.valid && form.get('email')?.value" 
                      class="fa-solid fa-circle-check text-success">
                    </i>
                    <i 
                      *ngIf="form.get('email')?.invalid && form.get('email')?.touched" 
                      class="fa-solid fa-circle-xmark text-danger">
                    </i>
                  </span>
                </div>
              }
              <app-form-errors [controlName]="form.controls['email']"></app-form-errors>
            </div>
          </div>
        </div>

        <!-- Sección para cambio de credenciales en modo edición -->
        <div class="row" *ngIf="isEditMode && !isViewMode">
          <div class="col-12 mb-3">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" formControlName="changePassword" id="changePasswordCheckbox">
              <label class="form-check-label" for="changePasswordCheckbox">
                Deseo cambiar mi contraseña
              </label>
            </div>
          </div>

          <div class="col-xl-6 col-lg-4 col-md-6 col-sm-6 col-12" *ngIf="wantToChangePassword">
            <div class="form-group mb-3">
              <label class="required-field">Nueva contraseña</label>
              <div>
                <input formControlName="password" type="password" class="form-control" />
              </div>
              <!-- Requisitos de contraseña -->
              <div class="password-requirements mt-2" [ngClass]="{'text-danger': form.controls['password'].dirty && form.controls['password'].invalid}">
                <small>
                  La contraseña debe cumplir los siguientes requisitos:
                </small>
                <ul class="small mt-1 ps-3">
                  <li *ngIf="form.controls['password'].dirty && (!form.controls['password'].value || form.controls['password'].value.length < 8)" class="text-danger">Al menos 8 caracteres</li>
                  <li *ngIf="form.controls['password'].value && form.controls['password'].value.length >= 8" class="text-success">Al menos 8 caracteres</li>
                  
                  <li *ngIf="form.controls['password'].dirty && hasUppercaseError()" class="text-danger">Al menos una letra mayúscula</li>
                  <li *ngIf="!hasUppercaseError() && form.controls['password'].value" class="text-success">Al menos una letra mayúscula</li>
                  
                  <li *ngIf="form.controls['password'].dirty && hasLowercaseError()" class="text-danger">Al menos una letra minúscula</li>
                  <li *ngIf="!hasLowercaseError() && form.controls['password'].value" class="text-success">Al menos una letra minúscula</li>
                  
                  <li *ngIf="form.controls['password'].dirty && hasDigitError()" class="text-danger">Al menos un número</li>
                  <li *ngIf="!hasDigitError() && form.controls['password'].value" class="text-success">Al menos un número</li>
                </ul>
              </div>
              <app-form-errors [controlName]="form.controls['password']"></app-form-errors>
            </div>
          </div>

          <div class="col-xl-6 col-lg-4 col-md-6 col-sm-6 col-12" *ngIf="wantToChangePassword">
            <div class="form-group mb-3">
              <label class="required-field">Confirmar contraseña</label>
              <div>
                <input formControlName="confirmPassword" type="password" class="form-control" />
              </div>
              <div *ngIf="form.controls['password'].value !== form.controls['confirmPassword'].value && form.controls['confirmPassword'].dirty" 
                 class="text-danger mt-1 small">
                Las contraseñas no coinciden
              </div>
              <div *ngIf="form.controls['password'].value === form.controls['confirmPassword'].value && form.controls['confirmPassword'].value && form.controls['confirmPassword'].dirty" 
                 class="text-success mt-1 small">
                Las contraseñas coinciden
              </div>
              <app-form-errors [controlName]="form.controls['confirmPassword']"></app-form-errors>
            </div>
          </div>
        </div>

        <h5 class="mt-2 mb-2">
          Datos generales
        </h5>
        <div class="row">
          <div class="col-xl-6 col-lg-4 col-md-6 col-sm-6 col-12">
            <div class="form-group mb-3">
              <label class="required-field">Tipo de Identificación</label>
                <div>
                  <select formControlName="typeIdentificationId" class="form-control" (change)="onDocumentTypeChange()">
                    <option value="">Seleccione</option>
                    <option *ngFor="let item of typeIdentList" [value]="item.id">{{ item.text }}</option>
                  </select>
                </div>
              <app-form-errors [controlName]="form.controls['typeIdentificationId']"></app-form-errors>
            </div>
          </div>
          <div class="col-xl-6 col-lg-4 col-md-6 col-sm-6 col-12">
            <div class="form-group mb-3">
              <label>Número de Identificación</label>
                <div>
                  <input formControlName="identification" type="text" class="form-control" [mask]="documentMask" [validation]="false"/>
                </div>
              <app-form-errors [controlName]="form.controls['identification']"></app-form-errors>
            </div>
          </div>
          <div class="col-xl-6 col-lg-4 col-md-6 col-sm-6 col-12">
            <div class="form-group mb-3">
              <label class="required-field">Nombre</label>
                <div>
                  <input formControlName="firstName" type="text" class="form-control" />
                </div>
              <app-form-errors [controlName]="form.controls['firstName']"></app-form-errors>
            </div>
          </div>
          <div class="col-xl-6 col-lg-4 col-md-6 col-sm-6 col-12">
            <div class="form-group mb-3">
              <label>Segundo nombre</label>
                <div>
                  <input formControlName="middleName" type="text" class="form-control" />
                </div>
              <app-form-errors [controlName]="form.controls['middleName']"></app-form-errors>
            </div>
          </div>
          <div class="col-xl-6 col-lg-4 col-md-6 col-sm-6 col-12">
            <div class="form-group mb-3">
              <label class="required-field">Apellido</label>
              <div>
                <input formControlName="lastName" type="text" class="form-control" />
              </div>
              <app-form-errors [controlName]="form.controls['lastName']"></app-form-errors>
            </div>
          </div>
          <div class="col-xl-6 col-lg-4 col-md-6 col-sm-6 col-12">
            <div class="form-group mb-3">
              <label>Segundo apellido</label>
              <div>
                <input formControlName="secondLastName" type="text" class="form-control" />
              </div>
              <app-form-errors [controlName]="form.controls['secondLastName']"></app-form-errors>
            </div>
          </div>
          <div class="col-xl-6 col-lg-4 col-md-6 col-sm-6 col-12">
            <div class="form-group mb-3">
              <label class="required-field">Sexo</label>
              <div>
                <select formControlName="sexId" class="form-control">
                  <option value="">Seleccione</option>
                  <option *ngFor="let s of sexList" [value]="s.id">{{ s.text }}</option>
                </select>
              </div>
              <app-form-errors [controlName]="form.controls['sexId']"></app-form-errors>
            </div>
          </div>
          <div class="col-xl-6 col-lg-4 col-md-6 col-sm-6 col-12">
            <div class="form-group mb-3">
              <label class="required-field">Fecha de nacimiento</label>
              <div>
                <input formControlName="birthDate" type="date" class="form-control"  />
              </div>
              <app-form-errors [controlName]="form.controls['birthDate']"></app-form-errors>
            </div>
          </div>
          <div class="col-xl-6 col-lg-4 col-md-6 col-sm-6 col-12">
            <div class="form-group mb-3">
              <label>Edad</label>
              <div>
                <input [value]="personAge" type="text" class="form-control" readonly="readonly" />
                <div *ngIf="birthDate.invalid && (birthDate.dirty || birthDate.touched)" class="text-danger">
                  <div *ngIf="birthDate.errors!['underage']">Debe tener al menos {{minAge}} años.</div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-6 col-lg-4 col-md-6 col-sm-6 col-12">
            <div class="form-group mb-3">
              <label class="required-field">País de Nacionalidad</label>
              <div>
                <select formControlName="nationalityId" class="form-control">
                  <option value="">Seleccione</option>
                  <option *ngFor="let n of nationalityList" [value]="n.id">{{ n.text }}</option>
                </select>
              </div>
              <app-form-errors [controlName]="form.controls['nationalityId']"></app-form-errors>
            </div>
          </div>
          <div class="col-xl-6 col-lg-4 col-md-6 col-sm-6 col-12">
            <div class="form-group mb-3">
              <label>Telefono principal</label>
              <div class="d-flex align-items-center gap-2">
                @if (isCountriesDropdownVisible) {
                  <app-country-list-dropdown [code]="useRDMask.primary.code" formControlName="phoneNumberData" class="form-control p-0"
                    style="max-width: 140px;" (countryChange)="onCountryChange($event, 'primary')" [disabled]="isViewMode"></app-country-list-dropdown>
                }
              <div>
                @if (useRDMask.primary.enabled) {
                  <input mask="(000) 000-0000" formControlName="phoneNumber" type="text" class="form-control mt-2" />
                }
                @else{
                  <input formControlName="phoneNumber" type="text" class="form-control mt-2" />
                }

              </div>
              </div>
              <app-form-errors [controlName]="form.controls['phoneNumber']"></app-form-errors>
            </div>
          </div>
          <div class="col-xl-6 col-lg-4 col-md-6 col-sm-6 col-12">
            <div class="form-group mb-3">
              <label>Celular</label>
              <div class="d-flex align-items-center gap-2">
              @if (isCountriesDropdownVisible) {
                <app-country-list-dropdown 
                    formControlName="cellPhoneData"
                    (countryChange)="onCountryChange($event, 'cel')"
                    class="form-control p-0"
                    style="max-width: 140px;" [code]="useRDMask.cel.code" [disabled]="isViewMode"
                  ></app-country-list-dropdown> 
              }
              <div class="input-group mb-3 mt-2">
                <div class="input-group-text">
                  <input 
                    class="form-check-input mt-0" 
                    type="checkbox" 
                    formControlName="cellPhoneHasWhatsapp" >
                  <i class="fa-brands fa-whatsapp mx-2"></i>
                </div>
                @if (useRDMask.cel.enabled) {
                  <input mask="(000) 000-0000" formControlName="cellPhone" type="text" class="form-control" />
                }
                @else {
                  <input formControlName="cellPhone" type="text" class="form-control" />
                }
                <app-form-errors [controlName]="form.controls['cellPhone']"></app-form-errors>
              </div>
              </div>
            </div>
          </div>
          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <div class="form-group mb-3">
              <label>Perfil profesional</label>
              <div>
                <app-dropdown [options]="professionalProfileList" formControlName="professionalProfileId"></app-dropdown>
              </div>
              <app-form-errors [controlName]="form.controls['professionalProfileId']"></app-form-errors>
            </div>
          </div>
          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <div class="form-group mb-3">
              <label>Descripción del perfil profesional</label>
              <div>
                <textarea class="form-control" rows="5" formControlName="professionalProfile"></textarea>
              </div>
              <app-form-errors [controlName]="form.controls['professionalProfile']"></app-form-errors>
            </div>
          </div>
        </div>
      </div>
  
      <!-- SECCIÓN FOTO PRINCIPAL -->
      <div class="col-xl-4 col-lg-12 col-md-12 col-sm-12 col-12">
        <div class="card">
          <div class="card-body position-relative">
            <!-- Overlay de carga para la foto de perfil -->
            <div *ngIf="isPhotoUploading" class="file-upload-overlay">
              <div class="file-upload-spinner"></div>
              <div class="file-upload-message">Subiendo foto...</div>
            </div>
            <!-- Overlay de error para la foto de perfil -->
            <div *ngIf="photoUploadError" class="file-upload-overlay file-upload-error">
              <i class="fa-solid fa-circle-exclamation fa-2x mb-2"></i>
              <div class="file-upload-message">{{ photoUploadError }}</div>
              <button class="btn btn-sm btn-light mt-2" (click)="photoUploadError = null">Cerrar</button>
            </div>
            <!-- Overlay de éxito para la fot de perfil -->
            <div *ngIf="photoUploadSuccess" class="file-upload-overlay file-upload-success">
              <i class="fa-solid fa-circle-check fa-2x mb-2"></i>
              <div class="file-upload-message">Foto subida correctamente</div>
              <button class="btn btn-sm btn-light mt-2" (click)="photoUploadSuccess = false">Cerrar</button>
            </div>
            <div class="d-flex align-items-center justify-content-center">
              <div style="position: relative; display: inline-block;">
                <img 
                  [src]="photoPreview || 'assets/Images/user.png'" 
                  onerror="this.src='assets/Images/No-image-found.jpg'; this.error=null;"
                  alt="User" 
                  class="img-fluid" />
                <button *ngIf="photoPreview" 
                        class="btn btn-danger btn-sm" 
                        (click)="removePhoto()"
                        style="position: absolute; top: 8px; right: 8px; z-index: 2; 
       border-radius: 50%; width: 32px; height: 32px; 
       display: flex; align-items: center; justify-content: center;">
                  <i class="fa-solid fa-xmark"></i>
                </button>
              </div>
            </div>
            <div class="position-absolute text-center w-100" style="bottom: 25px;" (click)="uploadFoto()" *ngIf="!isViewMode && !isPhotoUploading">
              <button type="button" class="btn btn-primary">
                Subir foto
              </button>
            </div>
            <div class="d-none">
              <input type="file" accept="image/*,application/pdf" id="fileFoto" (change)="onPhotoSelected($event)">
            </div>
          </div>
        </div>
  
        <h5 class="mt-3 mb-2">
          Documentos
        </h5>
        <div class="table-responsive position-relative">
          <!-- Overlay de carga para el documento -->
          <div *ngIf="isDocUploading" class="file-upload-overlay">
            <div class="file-upload-spinner"></div>
            <div class="file-upload-message">Subiendo documento...</div>
          </div>
          <!-- Overlay de error para el documento -->
          <div *ngIf="docUploadError" class="file-upload-overlay file-upload-error">
            <i class="fa-solid fa-circle-exclamation fa-2x mb-2"></i>
            <div class="file-upload-message">{{ docUploadError }}</div>
            <button class="btn btn-sm btn-light mt-2" (click)="docUploadError = null">Cerrar</button>
          </div>
          <!-- Overlay de éxito para el documento -->
          <div *ngIf="docUploadSuccess" class="file-upload-overlay file-upload-success">
            <i class="fa-solid fa-circle-check fa-2x mb-2"></i>
            <div class="file-upload-message">Documento subido correctamente</div>
            <button class="btn btn-sm btn-light mt-2" (click)="docUploadSuccess = false">Cerrar</button>
          </div>
          <table class="table table-theme">
            <thead>
              <tr>
                <th>Documento</th>
                <th class="text-center">Req.</th>
                <th width="120px" class="text-center">Acciones</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{ getIdentificationDocumentName() }} <span class="required-field" *ngIf="!isViewMode"></span></td>
                <td class="text-center">
                  <div class="form-check d-inline-block">
                    <input class="form-check-input" type="checkbox" disabled checked>
                  </div>
                </td>
                <td class="text-center">
                  <div class="d-flex justify-content-center gap-2">
                    <button 
                      *ngIf="!isViewMode && !isDocUploading"
                      type="button" 
                      class="btn btn-primary btn-sm" 
                      title="Subir" 
                      (click)="onDocReqClick(0)">
                      <i class="fa-solid fa-upload"></i>
                    </button>
                    <a 
                      *ngIf="cedulaPreview" 
                      [href]="cedulaPreview" 
                      target="_blank"
                      class="btn btn-outline-info btn-sm"
                      title="Ver documento">
                      <i class="fa-solid fa-eye"></i>
                    </a>
                    <button *ngIf="cedulaPreview" class="btn btn-danger btn-sm ms-2" (click)="removeDoc()">X</button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="small text-muted mt-2" *ngIf="!isViewMode">
          <i class="fa-solid fa-circle-info me-1"></i>
          Los campos marcados con <span class="required-field"></span> son obligatorios para guardar o crear la cuenta.
        </div>
        <div class="d-none">
          <input type="file" accept="image/*,application/pdf" id="fileDocReq" (change)="onDocReqSelected($event)">
        </div>
      </div>
    </div>
  
    <div class="row mb-2">
      <div class="col-6">
        <h5 class="mt-2 mb-2">
          Domicilio
        </h5>
      </div>
      <div class="col-6">
        <div class="text-end">
          <button 
            *ngIf="!isViewMode"
            type="button" 
            class="btn btn-outline-primary btn-sm" 
            (click)="openAddressDialog()">
            <i class="fa-regular fa-square-plus"></i>
            Nuevo
          </button>
        </div>
      </div>
    </div>
  
    <!-- TABLA DE DIRECCIONES -->
    <div class="table-responsive">
      <table class="table table-theme">
        <thead>
          <tr>
            <th>País</th>
            <th>Estado/Provincia</th>
            <th>Municipio/Ciudad</th>
            <th>Sector/Barrio</th>
            <th>Calle</th>
            <th>Principal</th>
            <th width="110px"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of visibleAddresses; let i = index">
            <td>{{ item.countryName }}</td>
            <td>{{ item.stateName }}</td>
            <td>{{ item.city }}</td>
            <td>{{ item.districtName ?? 'N/A' }}</td>
            <td>{{ item.address }}</td>
            <td>
              <i *ngIf="item.isPrimary" class="fa-regular fa-circle-check text-success fa-lg"></i>
            </td>
            <td class="d-flex align-items-center justify-content-center">
              <button *ngIf="!isViewMode" type="button" class="btn btn-outline-success me-2" (click)="editAddress(item, i)">
                <i class="fa-solid fa-pen-to-square"></i>
              </button>
              <button type="button" class="btn btn-outline-info me-2" (click)="viewAddress(item)">
                <i class="fa-solid fa-eye"></i>
              </button>
              <button *ngIf="!isViewMode" type="button" class="btn btn-outline-danger" (click)="removeAddress(i)">
                <i class="fa-regular fa-trash-can"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  
    <h5 class="mt-2 mb-2" *ngIf="!isEditMode && !isViewMode">
      Accesos
    </h5>
    <div class="row" *ngIf="!isEditMode && !isViewMode">
      <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
        <div class="form-group mb-3">
          <label>Password</label>
          <div>
            <input formControlName="password" type="password" class="form-control" />
          </div>
          <div 
            *ngIf="form.get('password')?.errors?.['passwordInvalid'] && form.get('password')?.touched" 
            class="text-danger mt-1">
            {{ form.get('password')?.errors?.['passwordInvalid'] }}
          </div>
        </div>
      </div>
      <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
        <div class="form-group mb-3">
          <label>Confirmación</label>
          <div>
            <input formControlName="confirmPassword" type="password" class="form-control" />
          </div>
          <div 
            *ngIf="form.get('confirmPassword')?.errors?.['mustMatch'] && form.get('confirmPassword')?.touched" 
            class="text-danger mt-1">
            Las contraseñas no coinciden
          </div>
        </div>
      </div>
    </div>
  
    <hr class="mt-2 mb-2" *ngIf="typePerson == rolesId.Member" />
    <br  *ngIf="typePerson == rolesId.Member"/>
    <p class="mt-2 mb-2" *ngIf="typePerson == rolesId.Member">
      Con mi cuenta de RedLaboralRD deseo:
    </p>
    <div class="row" *ngIf="typePerson == rolesId.Member">
      <!-- <div class="col-12">
        <div class="form-check">
          <input 
            class="form-check-input" 
            type="checkbox" 
            formControlName="wantToPublishOffers"
            id="redLaboralOpcion1">
          <label class="form-check-label" for="redLaboralOpcion1">
            Publicar ofertas de empleo y buscar posibles candidatos
          </label>
        </div>
      </div> -->
      <div class="col-12 mb-3">
        <div class="form-check">
          <input 
            class="form-check-input" 
            type="checkbox" 
            formControlName="wantToSearchJobs"
            id="redLaboralOpcion2">
          <label class="form-check-label" for="redLaboralOpcion2">
            <span class="fw-medium">Buscar empleo y participar en la ofertas laborales publicadas</span>
          </label>
        </div>
      </div>
      <div class="col-12">
        <div class="form-check">
          <input 
            class="form-check-input" 
            type="checkbox" 
            formControlName="isIndependentProfessional"
            id="redLaboralOpcion3"
            (change)="onIndependentProfessionalChange()">
          <label class="form-check-label" for="redLaboralOpcion3">
            <span class="fw-medium">Soy un profesional independiente y deseo ofrecer mis servicios
            a las diferentes compañias.</span>
          </label>
        </div>
      </div>
      
      <!-- Sección de Perfil Profesional Independiente -->
      <div class="col-12 mt-3" *ngIf="form.get('isIndependentProfessional')?.value">
        <div class="card">
          <div class="card-header">
            <h6 class="mb-0">Perfil Profesional Independiente</h6>
          </div>
          <div class="card-body">
            <!-- Mostrar solo en modo edición -->
            <div class="row" *ngIf="isEditMode">
              <div class="col-12">
                <div class="form-group mb-3">
                  <label>Currículum a mostrar como profesional independiente</label>
                  <div *ngIf="loadingResumes" class="text-center py-3">
                    <div class="spinner-border spinner-border-sm text-primary" role="status">
                      <span class="visually-hidden">Cargando...</span>
                    </div>
                    <p class="mt-2 mb-0 text-muted">Cargando currículums...</p>
                  </div>
                  
                  <div *ngIf="!loadingResumes && resumes.length > 0">
                    <select formControlName="publicResumeId" class="form-control">
                      <option value="">Seleccione un currículum</option>
                      <option *ngFor="let resume of resumes" [value]="resume.id">{{ resume.name }}</option>
                    </select>
                    <div class="form-text text-muted mt-2">
                      El currículum seleccionado será visible para empresas que busquen profesionales independientes.
                    </div>
                  </div>
                  
                  <div *ngIf="!loadingResumes && resumes.length === 0" class="alert alert-info">
                    <i class="fa-solid fa-info-circle me-2"></i>
                    No tiene currículums disponibles. Por favor, cree un currículum primero para poder usarlo como perfil de profesional independiente.
                  </div>
                </div>
              </div>
            </div>
            
            <!-- Mensaje informativo en modo registro -->
            <div class="row" *ngIf="!isEditMode">
              <div class="col-12">
                <div class="alert alert-success">
                  <i class="fa-solid fa-check-circle me-2"></i>
                  <strong>¡Perfecto!</strong> Una vez creada su cuenta, podrá crear y seleccionar un currículum para mostrarlo como profesional independiente.
                </div>
                <p class="text-muted mb-0">
                  <i class="fa-solid fa-lightbulb me-1"></i>
                  Después de registrarse, acceda a la sección de currículums para crear su perfil profesional.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <br />
    <hr class="mt-2 mb-2" />
  
    <div class="mt-4 mb-3" *ngIf="showSaveRegister && !isViewMode">
      <div class="card shadow-sm border-primary">
        <div class="card-body">
          <h6 class="mb-3 text-primary"><i class="fa-solid fa-circle-info me-2"></i>Términos legales</h6>
          <div class="form-check mb-3">
            <input 
              class="form-check-input" 
              type="checkbox" 
              formControlName="privacityTermsAccepted"
              id="PoliticaPrivacidad">
            <label class="form-check-label" for="PoliticaPrivacidad">
              Acepto la 
              <a 
                href="javascript:void(0);" 
                class="text-decoration-none fw-bold" 
                data-bs-toggle="modal" 
                data-bs-target="#modalPoliticaPrivacidad">
                política de privacidad
              </a>
            </label>
          </div>
          <div class="form-check mb-3">
            <input 
              class="form-check-input" 
              type="checkbox" 
              formControlName="refundTermsAccepted"
              id="TerminosCondiciones">
            <label class="form-check-label" for="TerminosCondiciones">
              Acepto los 
              <a 
                href="javascript:void(0);" 
                class="text-decoration-none fw-bold" 
                data-bs-toggle="modal" 
                data-bs-target="#modalTerminosCondiciones">
                términos y condiciones
              </a>
            </label>
          </div>
        </div>
      </div>
      <div class="text-end mt-3" *ngIf="!isEditMode && !isViewMode && showSaveRegister">
        <button type="button" class="btn btn-primary btn-lg" (click)="onSubmit()" [disabled]="isSaving || isLoading">
          <span *ngIf="isSaving" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
          {{ isSaving ? 'Creando cuenta...' : 'Crear cuenta' }}
        </button>
      </div>
    </div>
    
    <div class="mt-2 mb-2 text-end" *ngIf="isEditMode && showSaveButton && !isViewMode">
      <button type="button" class="btn btn-primary btn-lg" (click)="onSubmit()" [disabled]="isSaving || isLoading">
        <span *ngIf="isSaving" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
        {{ isSaving ? 'Guardando...' : 'Guardar' }}
      </button>
    </div>
  </ng-template>
</div>

  
  <!-- Modals de Términos y Política (opcional, si lo usas en bootstrap) -->
  <div class="modal fade" id="modalTerminosCondiciones" tabindex="-1" aria-labelledby="modalTerminosCondicionesLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5" id="modalTerminosCondicionesLabel">Términos y condiciones</h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <p class="text-justify">
          Al utilizar RedLaboralRD, usted acepta cumplir con nuestras condiciones de uso. Los usuarios deben proporcionar información verídica y actualizada. RedLaboralRD se reserva el derecho de modificar estas condiciones en cualquier momento. El uso continuado de la plataforma después de cualquier modificación constituye la aceptación de dichos cambios. No está permitido el uso indebido de la información disponible en la plataforma ni el intento de vulnerar la seguridad del sistema. El incumplimiento de estos términos podría resultar en la suspensión o eliminación de la cuenta.
        </p>
        </div>
      </div>
    </div>
  </div>
  
  <div class="modal fade" id="modalPoliticaPrivacidad" tabindex="-1" aria-labelledby="modalPoliticaPrivacidadLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5" id="modalPoliticaPrivacidadLabel">Política de privacidad</h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <p class="text-justify">
          POLÍTICA DE PRIVACIDAD DE REDLABORALRD <br>
          Fecha de última actualización: 11 de julio de 2025<br><br>
          En Redlaboralrd, valoramos su privacidad y nos comprometemos a proteger sus datos personales. Esta Política de Privacidad describe cómo recopilamos, usamos, procesamos y compartimos su información cuando utiliza nuestra plataforma.<br><br>
          <strong>1. Información que Recopilamos</strong><br>
          <strong>1.1. Información que usted nos proporciona directamente:</strong><br>
          <u>Para Colaboradores:</u> Datos de registro (nombre completo, correo, teléfono, etc.), información curricular, contenido de comunicaciones.<br>
          <u>Para Empresas:</u> Datos de registro (nombre, RNC, contacto, etc.), perfil de empresa, datos de ofertas laborales.<br><br>
          <strong>1.2. Información recopilada automáticamente:</strong><br>
          Datos de uso, técnicos, cookies y tecnologías similares.<br><br>
          <strong>2. Finalidad del Tratamiento de Datos</strong><br>
          Proveer y mantener la plataforma, personalizar experiencia, mejorar servicios, comunicación, seguridad, cumplimiento legal.<br><br>
          <strong>3. Compartición de Información</strong><br>
          Entre usuarios, proveedores de servicios, requerimientos legales, transferencias de negocio y con su consentimiento.<br><br>
          <strong>4. Responsabilidad</strong><br>
          Redlaboralrd actúa como intermediario. Las partes (colaborador y empresa) son responsables de sus datos compartidos.<br><br>
          <strong>5. Seguridad</strong><br>
          Aplicamos medidas de seguridad razonables, pero no garantizamos protección absoluta.<br><br>
          <strong>6. Retención de Datos</strong><br>
          Conservamos información según la necesidad legal y operativa.<br><br>
          <strong>7. Derechos del Usuario</strong><br>
          Acceder, rectificar, eliminar, oponerse al tratamiento, revocar consentimiento.<br><br>
          <strong>8. Cambios a la Política</strong><br>
          Podemos actualizar esta política. Notificaremos los cambios importantes.<br><br>
          <strong>9. Contacto</strong><br>
          Si tiene preguntas, contáctenos a través de [correo de Redlaboralrd] o [teléfono].
        </p>
        </div>
      </div>
    </div>
  </div>
